const filterTypeEnum = {
  INPUT: "input",
  SELECT: "select",
  DATE_TIME_RANGE: "date_time_range",
  DROPDOWN_SELECT: "dropdown_select",
};

export default filterTypeEnum;
